/**
 * Money utilities. All amounts in kopecks (integer).
 * 100 kopecks = 1 ruble. We render in rubles.
 */

const RU = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatKopecks(kopecks: number): string {
  if (!Number.isFinite(kopecks)) return "—";
  const rubles = kopecks / 100;
  // Drop fractional if .00
  if (rubles % 1 === 0) {
    return `${RU.format(rubles)} ₽`;
  }
  return `${RU.format(rubles)} ₽`;
}

export function rublesToKopecks(rubles: number): number {
  return Math.round(rubles * 100);
}
